export default class Passport {
    constructor(adapter = {
        link: ""
    }) {
        this.link = adapter.link;
    }
}